import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ngModel][phone]',
  host: {
    '(blur)': 'onInputBlur($event)',
    '(focus)': 'onInputFocus($event)'
  }
})
export class PhoneMask {
  constructor(public model: NgControl) {}

  onInputFocus(event) {
    if(event.target.value && event.target.value !== '') {
      var newVal = event.target.value.replace(/[()-]/g,'');

      this.model.valueAccessor.writeValue(newVal);
    }
  }

  onInputBlur(event) {
    if(event.target.value && event.target.value !== '') {
      var newVal = event.target.value;

      if(/^\d+$/.test(newVal)) {

        if(newVal.length <= 3) {
          newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if(newVal.length <= 6) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1)$2');
        } else {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1)$2-$3');
        }

      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/format_phone_number/format_phone_number.directive.ts